import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { useCustomPageFilterQuery } from '../../../hooks/filter';
import { FilterConfigDto } from '../../../store/states/filterTypes';
import { Filter } from '../Filter';
import { FilterActions } from '../FilterActions';
import { type FilterPersistenceMode } from '../FilterPersistenceIcon';
import { isDualInputRangeFilterDisplay } from '../util';

import styles from '../filters.module.scss';

type CustomPageFiltersProps = {
  activeCustomFilterConfigs: FilterConfigDto[];
  customFilterInstanceId: string;
  pageFilterInstanceId: string;
  pageId: string;
  showFilterActions?: boolean;
  resetAllPageFilters: (
    pageFilterInstanceId: string,
    customFilterInstanceId: string
  ) => void;
  persistenceMode?: FilterPersistenceMode;
  onPersistenceClick?: () => void;
};

export const CustomPageFilters = ({
  activeCustomFilterConfigs,
  customFilterInstanceId,
  pageFilterInstanceId,
  pageId,
  showFilterActions = true,
  resetAllPageFilters,
  persistenceMode,
  onPersistenceClick,
}: CustomPageFiltersProps) => {
  const { t } = useTranslation();

  const query = useCustomPageFilterQuery(
    pageId,
    customFilterInstanceId,
    pageFilterInstanceId,
    activeCustomFilterConfigs
  );

  const isFetching = query.isFetching || !query.isSuccess;

  if (activeCustomFilterConfigs.length === 0) {
    return null;
  }

  return (
    <>
      {activeCustomFilterConfigs.map((filterConfig, index) => {
        return (
          <div className={styles['pagefilter__wrapper']} key={filterConfig.key}>
            <div
              className={clsx(
                styles['pagefilter__filter'],
                isDualInputRangeFilterDisplay(filterConfig.display) &&
                  styles['pagefilter__filter--no-width']
              )}
            >
              <Filter
                filterConfig={filterConfig}
                entityId={customFilterInstanceId}
                isFetching={isFetching}
                filterData={query.validatedData?.[filterConfig.key]}
              />
            </div>
            {showFilterActions &&
              index + 1 === activeCustomFilterConfigs.length && (
                <FilterActions
                  showResetIcon={true}
                  resetTitle={t('app.pageFilter.reset')}
                  onResetClick={() =>
                    resetAllPageFilters(
                      pageFilterInstanceId,
                      customFilterInstanceId
                    )
                  }
                  persistenceMode={persistenceMode}
                  onPersistenceClick={onPersistenceClick}
                />
              )}
          </div>
        );
      })}
    </>
  );
};
